import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { ReplitAppField } from './ReplitAppExtension';

export const ReplitAppFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'ReplitApp',
    component: ReplitAppField,
  }),
);
